import React, { useEffect } from "react";
import Layout from "@/HOC";
import { Breadcrumb, Spin } from "antd";
import { CheckCircleTwoTone } from "@ant-design/icons";
import { useRouter } from "next/router";
import { getPaymentStatus } from "@/utils/apis/payment/payment-status.api";
import { useAppContext } from "@/context";
import { updateSubscription } from "@/utils/apis/packages/post-subscription.api";
import { updateUser } from "@/utils/apis/auth/update-user.api";
import { registerUser } from "@/utils/apis/auth/signup.api";
import { handleError } from "@/utils/common";
import Link from "next/link";
import Cookies from "js-cookie";
import Head from "next/head";
import DefaultSeo from "@/component/seo/DefaultSeo";

function PaymentSuccess() {
  const router = useRouter();
  const currentPageName = router.pathname.replace(/^\//, "").replace(/-/g, " ");
  const formattedPageName =
    currentPageName.charAt(0).toUpperCase() + currentPageName.slice(1);

  const paymentId = router.query.session_id as string;
  const planId = router.query.plan as string;

  const { user } = useAppContext();

  const { fetchUser, setUser } = useAppContext();

  const handlePaymentStatus = async () => {
    if (!paymentId || !planId) return;
    const res = await getPaymentStatus(paymentId);
    console.log(res);

    const isLoggedin = Boolean(Cookies.get("x-access"));

    if (res.data.success) {
      if (isLoggedin) {
        // handle the subscription update
        let data = {
          currentPackage: planId,
          sessionId: paymentId,
        };
        const res = await updateSubscription(data);
        //On successful payment we will update the planId to the paid one
        const formData = new FormData();
        formData.append("packageId", planId);
        await updateUser(formData as any);
        if (res.data.success) {
          console.log(res.data.data);
          fetchUser();
          router.replace("/my-plan");
        } else {
          console.log(res.data.message);
        }
      } else {
        // handle the signup process with the purchased subscription
        const savedUserDetails = JSON.parse(
          localStorage.getItem("userDetails") || "{}"
        );
        localStorage.removeItem("userDetails");
        try {
          const data = await registerUser({
            ...savedUserDetails,
            sessionId: paymentId,
          });
          if (data.data.success) {
            setUser(res.data.data);
            fetchUser();
            router.replace("/dashboard");
          }
        } catch (error: any) {
          handleError(error.response.data.message || error.message);
        }
      }
    }
  };

  useEffect(() => {
    handlePaymentStatus();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [paymentId, planId]);

  return (
    <div>
      <DefaultSeo
        title="Payment Success"
        description="Your payment was successful. Updating your subscription..."
      />
      <Head>
        <meta
          name="viewport"
          content="width=device-width, initial-scale=1, maximum-scale=1, user-scalable=no"
        />
      </Head>
      <Layout>
        <div className="Breadcrumb">
          <div className="main">
            <Breadcrumb
              items={[
                {
                  title: (
                    <Link href={user ? "/dashboard" : "/home"}>
                      {user ? "Dashboard" : "Home"}
                    </Link>
                  ),
                },
                {
                  title: "Payment Success",
                },
              ]}
            />
          </div>
        </div>
        <div className="main">
          <div className="PaymentMain">
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <div
                style={{
                  background: "#fff",
                  width: 400,
                  height: 300,
                  borderRadius: 18,
                  boxShadow: "3px 5px 13px #ddd",
                  display: "flex",
                  flexDirection: "column",
                  gap: 16,
                }}
              >
                <div
                  style={{
                    position: "relative",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    height: 100,
                    marginTop: 40,
                  }}
                >
                  <div
                    style={{
                      background: "#A9DFBF",
                      width: 100,
                      height: 100,
                      position: "absolute",
                      zIndex: 1,
                      borderRadius: 50,
                      opacity: 0.3,
                    }}
                  />
                  <div
                    style={{
                      background: "#82E0AA",
                      width: 80,
                      height: 80,
                      zIndex: 2,
                      position: "absolute",
                      borderRadius: 40,
                      opacity: 0.5,
                    }}
                  />
                  <div
                    style={{
                      position: "absolute",
                      zIndex: 3,
                      background: "#fff",
                      width: 60,
                      height: 60,
                      borderRadius: 30,
                    }}
                  >
                    <CheckCircleTwoTone
                      style={{
                        fontSize: 60,
                      }}
                      twoToneColor="#27AE60"
                    />
                    {/* <Succesc color={"#27AE60"} size={60} /> */}
                  </div>
                </div>
                <span
                  style={{
                    fontSize: 30,
                    alignSelf: "center",
                    margin: "20px 0px 0px 0px",
                    fontWeight: "bold",
                  }}
                >
                  Payment Successful
                </span>

                <span
                  style={{
                    fontSize: 16,
                    alignSelf: "center",
                    fontFamily: "sans-serif",
                    display: "flex",
                    alignItems: "center",
                    gap: "1rem",
                  }}
                >
                  <span>Updating your subscription...</span>
                  <Spin />
                </span>
              </div>
            </div>
          </div>
        </div>
      </Layout>
    </div>
  );
}

export default PaymentSuccess;
